<div class="empty-data-card" [ngStyle]="{
    'margin-top': mt,
    'margin-bottom': mb
  }">
    <div class="anime-content">
        <div class="animation">
            <app-svg-loader width="32px" url="/assets/illustrations/empty-bubbles.svg"></app-svg-loader>
        </div>

        <div class="message">
            {{ messageText }}
        </div>
    </div>

    <div class="affirm-btn" *ngIf="affirmText" (click)="onClickAffirm()">
        <p class="affirm-text">{{ affirmText }}</p>
    </div>
</div>